import "bootstrap"

window.modalTab = function (target, tab, others = 'hidden') {
    const modal = $(target);
    if (modal.length) {
        let navs = modal.find('.nav li');
        if (tab) {
            navs.removeClass('active default-active disabled hidden');
            navs.filter('.' + tab).addClass('active default-active');
            modal.find('.modal-body .tab-pane').removeClass('active default-active');
            modal.find(navs.filter('.' + tab).find('a').attr('href')).addClass('default-active active');
        } else {
            navs.removeClass('disabled hidden');
        }
        if (others === 'hidden') {
            navs.not('.' + tab).addClass('hidden');
        } else if (others === 'disabled') {
            navs.not('.' + tab).addClass('disabled');
        } //  default behaviour is none.
        modal.modal('show');
    } else {

    }

}
$(document).on("click", '[data-toggle="modal-tab"]', function (e) {
    window.modalTab($(this).data('target'), $(this).data('tab'), $(this).data('show-other'))
    return false;
});
